import styled from '@emotion/styled';
import { palette, radius, spacing, typography } from '../../../../style-utils/theme';

/** The reservations screen's operations parts (plan S8, SC-2). Tokens only. */

export const Banner = styled.section<{ $done: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${spacing.xs};
  min-width: 0;
  padding: ${spacing.sm};
  border-radius: ${radius.md};
  border: 1px solid ${palette.line};
  background: ${p => (p.$done ? palette.successSoft : palette.warningSoft)};
`;

export const BannerLine = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing.xs} ${spacing.sm};
  min-width: 0;
  font-family: ${typography.ui};
  font-size: ${typography.size.sm}px;
  color: ${palette.ink};
`;

export const BannerText = styled.p`
  margin: 0;
  min-width: 0;
  overflow-wrap: anywhere;
`;

export const CardBox = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${spacing.xs};
  min-width: 0;
  padding: ${spacing.sm};
  border: 1px solid ${palette.line};
  border-radius: ${radius.md};
  background: ${palette.surface};
`;

export const CardHead = styled.h3`
  margin: 0;
  font-family: ${typography.ui};
  font-size: ${typography.size.base}px;
  font-weight: ${typography.weight.semibold};
  color: ${palette.ink};
`;

export const List = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
  font-family: ${typography.ui};
  font-size: ${typography.size.sm}px;
  color: ${palette.inkSoft};
`;

export const Item = styled.li`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing.half} ${spacing.xs};
  min-width: 0;
  overflow-wrap: anywhere;
`;

export const Muted = styled.span`
  color: ${palette.slate};
  font-variant-numeric: tabular-nums;
`;

export const Bridge = styled.span`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${spacing.xs} ${spacing.sm};
  min-width: 0;
  font-family: ${typography.ui};
  font-size: ${typography.size.sm}px;
  color: ${palette.inkSoft};
`;

export const Strong = styled.span`
  font-weight: ${typography.weight.semibold};
  color: ${palette.ink};
`;

export const Times = styled.span`
  min-width: 0;
  overflow-wrap: anywhere;
  font-variant-numeric: tabular-nums;
`;
